import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabel: {
		id: 'jpd-project-template-onboarding-modal.aria-label',
		defaultMessage: 'Jira Product Discovery onboarding modal',
		description: 'Aria label for the onboarding modal',
	},
	projectNameDefault: {
		id: 'jpd-project-template-onboarding-modal.project-name',
		defaultMessage: 'Product discovery',
		description:
			'Label for the project name as default, this will be the default project name for Jira Product Discovery',
	},
	projectNameLabel: {
		id: 'jpd-project-template-onboarding-modal.project-name-label',
		defaultMessage: 'Project name',
		description: 'Label for the project name input field as default',
	},
	projectNameLabelGalaxia: {
		id: 'jpd-project-template-onboarding-modal.project-name-label-galaxia',
		defaultMessage: 'Space name',
		description: 'Label for the space name input field as default',
	},
	projectNamePlaceholder: {
		id: 'jpd-project-template-onboarding-modal.project-name-placeholder',
		defaultMessage: 'Enter your project name here',
		description: 'Placeholder text for the project name input field',
	},
	projectNamePlaceholderGalaxia: {
		id: 'jpd-project-template-onboarding-modal.project-name-placeholder-galaxia',
		defaultMessage: 'Enter your space name here',
		description: 'Placeholder text for the space name input field',
	},
	projectDescription: {
		id: 'jpd-project-template-onboarding-modal.project-description',
		defaultMessage:
			'Your first discovery project is ready to kick off. Use it to evaluate and compare ideas.',
		description: 'Default onboarding modal description for a Jira Product Discovery project',
	},
	projectDescriptionGalaxia: {
		id: 'jpd-project-template-onboarding-modal.project-description-galaxia',
		defaultMessage:
			'Your first discovery space is ready to kick off. Use it to evaluate and compare ideas.',
		description: 'Default onboarding modal description for a Jira Product Discovery space',
	},
	projectTitleProductRoadmap: {
		id: 'cross-flow-onboarding-modal.project-title.product-roadmap',
		defaultMessage: 'Product roadmap',
		description: 'Product roadmap project title of JPD',
	},
	projectTitlePrioritization: {
		id: 'cross-flow-onboarding-modal.project-title.prioritizatino',
		defaultMessage: 'Prioritization',
		description: 'Prioritization project title of JPD',
	},

	logIdeas: {
		id: 'cross-flow-onboarding-modal.jpd.feature.log-ideas',
		defaultMessage: 'Log ideas and use insights to prioritize them',
		description: 'Feature: capturing ideas and insights',
	},
	shareRoadmaps: {
		id: 'cross-flow-onboarding-modal.jpd.share-roadmaps',
		defaultMessage: 'Share custom roadmaps with anyone',
		description: 'Feature: sharing custom roadmaps',
	},
	connectToJira: {
		id: 'cross-flow-onboarding-modal.jpd.connect-to-jira',
		defaultMessage: 'Easily connect ideas into Jira for delivery',
		description: 'Feature: connecting ideas into Jira for delivery',
	},
	ideas: {
		id: 'cross-flow-onboarding-modal.jpd-feature-ideas-title',
		defaultMessage: 'Ideas',
		description: 'Title for a particular feature in JPD',
	},
	roadmap: {
		id: 'cross-flow-onboarding-modal.jpd-feature-share-roadmap-title',
		defaultMessage: 'Roadmap',
		description: 'Title for a particular feature in JPD',
	},
	delivery: {
		id: 'cross-flow-onboarding-modal.jpd-feature-delivery-title',
		defaultMessage: 'Delivery',
		description: 'Title for a particular feature in JPD',
	},
	roadmapProjectNameDefault: {
		id: 'cross-flow-onboarding-modal.project-name-default',
		defaultMessage: 'Product roadmap',
		description:
			'Default project name for JPD, this is the prefilled name in the project name input field',
	},
	prioritizationProjectNameDefault: {
		id: 'cross-flow-onboarding-modal.prioritization-project-name-default',
		defaultMessage: 'Prioritization',
		description:
			'Default project name for Prioritization template, this is the prefilled name in the project name input field',
	},
	modalTitleDefault: {
		id: 'cross-flow-onboarding-modal.onboarding-template-title-default',
		defaultMessage: 'Name your project',
		description: 'Default onboarding modal heading',
	},
	modalTitleDefaultGalaxia: {
		id: 'cross-flow-onboarding-modal.onboarding-template-title-default-galaxia',
		defaultMessage: 'Name your space',
		description: 'Default onboarding modal heading',
	},
	onboardingSpaceTemplateTitleDefaultGalaxia: {
		id: 'cross-flow-onboarding-modal.onboarding-space-template-title-default-galaxia',
		defaultMessage: 'Name your space',
		description: 'Default onboarding modal heading for space',
	},
	productRoadmapProjectDescription: {
		id: 'cross-flow-onboarding-modal.onboarding-template-product-roadmap-project-description',
		defaultMessage:
			'Your first discovery project is ready to kick off. Use it to align your team with product roadmaps.',
		description: 'Default onboarding modal description for product roadmap project',
	},
	onboardingTemplateProductRoadmapProjectDescription: {
		id: 'cross-flow-onboarding-modal.onboarding-template-product-roadmap-project-description',
		defaultMessage:
			'Your first discovery project is ready to kick off. Use it to align your team with product roadmaps.',
		description: 'Default onboarding modal description for product roadmap project',
	},
	productRoadmapProjectDescriptionGalaxia: {
		id: 'cross-flow-onboarding-modal.onboarding-template-product-roadmap-project-description-galaxia',
		defaultMessage:
			'Your first discovery space is ready to kick off. Use it to align your team with product roadmaps.',
		description: 'Default onboarding modal description for product roadmap space',
	},
	onboardingTemplateProductRoadmapSpaceDescriptionGalaxia: {
		id: 'cross-flow-onboarding-modal.onboarding-template-product-roadmap-space-description-galaxia',
		defaultMessage:
			'Your first discovery space is ready to kick off. Use it to align your team with product roadmaps.',
		description: 'Default onboarding modal description for product roadmap space',
	},
	projectTitleProductDiscovery: {
		id: 'cross-flow-onboarding-modal.project-title.product-discovery',
		defaultMessage: 'Product discovery',
		description: 'Product discovery project title of JPD',
	},
	productDiscoveryProjectNameDefault: {
		id: 'cross-flow-onboarding-modal.product-discovery-project-name-default',
		defaultMessage: 'Product discovery',
		description: 'Default project name for Product Discovery template',
	},
	productDiscoveryProjectDescription: {
		id: 'cross-flow-onboarding-modal.onboarding-template-product-discovery-project-description',
		defaultMessage:
			'Your first discovery project is ready to kick off. Use it to evaluate and compare ideas.',
		description: 'Default onboarding modal description for product discovery project',
	},
	productDiscoveryProjectDescriptionGalaxia: {
		id: 'cross-flow-onboarding-modal.onboarding-template-product-discovery-project-description-galaxia',
		defaultMessage:
			'Your first discovery space is ready to kick off. Use it to evaluate and compare ideas.',
		description: 'Default onboarding modal description for product discovery space',
	},
	productDiscoveryAriaLabel: {
		id: 'cross-flow-onboarding-modal.onboarding-template-product-discovery-aria-label',
		defaultMessage: 'Jira Product Discovery onboarding modal',
		description: 'Aria label for the onboarding modal for product discovery project',
	},
	portfolioManagementAriaLabel: {
		id: 'cross-flow-onboarding-modal.onboarding-template-portfolio-management-aria-label',
		defaultMessage: 'Jira Product Discovery Portfolio Management template onboarding modal',
		description: 'Aria label for the onboarding modal for portfolio management project',
	},
	portfolioManagementProjectNameDefault: {
		id: 'cross-flow-onboarding-modal.portfolio-management-project-name-default',
		defaultMessage: 'Portfolio',
		description:
			'Default project name for Portfolio Management template, this is the prefilled name in the project name input field',
	},
});
